<app-global-data (OnCountryListReady)="OnCountryList($event)"></app-global-data>
<app-alert-box-component 
  (OnButtonClick)="onAlertButtonClick($event)"
  (OnAlertClose)="closeAlert($event)" 
  (OnAlertVisibility)="alertVisibility($event)"
  [bShowSecondButton]="bShowSecondAlertButton"
  [alertHeaderText]="alertHeaderText" 
  [alertBodyText]="alertBodyText" 
  [closeButtonText]="alertCloseButtonText"
  [secondButtonText]="alertSecondButtonText"
  [data]="alertBoxData"
  [bAlert]="bAlert"></app-alert-box-component>

<c-modal [visible]="bShowReason" alignment="center" [backdrop]="'static'">
    <form cForm class="row g-2" [formGroup]="rejectionForm" class="needs-validation" novalidate>
        <c-modal-header>
            <h5 cModalTitle>Why do you want to reject this customer?</h5>
            <button (click)="closeReasonModal()" cButtonClose></button>
        </c-modal-header>
        <c-modal-body>
        <c-input-group class="mb-3 has-validation" >
            <span cInputGroupText>
                Reason
            </span>
            <input [valid]="bValidReason" cFormControl formControlName="reasonControl" id="RejectReason" type="text"/>
            <c-form-feedback [valid]="ifReasonValid() === ''?true:false">{{ifReasonValid()}}</c-form-feedback>
        </c-input-group>
        </c-modal-body>
        <c-modal-footer>
            <button cButton color="secondary" (click)="closeReasonModal()">
            Don't want to reject
            </button>
            <button cButton color="primary" (click)="RejectCustomer()">Confirmed - Please reject</button>
        </c-modal-footer>
    </form>
</c-modal>

<c-modal [visible]="bShowActivationReason" alignment="center" [backdrop]="'static'">
    <form cForm class="row g-2" [formGroup]="activationRejectionForm" class="needs-validation" novalidate>
        <c-modal-header>
            <h5 cModalTitle>Please Confirm</h5>
            <button (click)="closeActivationReasonModal()" cButtonClose></button>
        </c-modal-header>
        <c-modal-body>
          There is a request to {{activationApprovalRequestType}} this customer. Do you want to Approve or Reject this request?
        </c-modal-body>
        <c-modal-footer>
            <div class="row">
              <div class="col">
                <button cButton color="primary" (click)="approveActivationRequest(true)">
                  Approve
                </button>
              </div>
              <div class="col">
                <button cButton color="danger" (click)="approveActivationRequest(false)">
                  Reject
                </button>
              </div>
              <div class="col">
                <button cButton color="secondary" (click)="closeActivationReasonModal()">
                  Cancel
                </button>
              </div>
            </div>
        </c-modal-footer>
    </form>
</c-modal>
<c-modal [visible]="bApprove" alignment="center" [backdrop]="'static'">
  <form cForm class="row g-2" [formGroup]="rejectionForm" class="needs-validation" novalidate>
      <c-modal-header>
          <h5 cModalTitle>Success</h5>
          <button (click)="closeApproveModal()" cButtonClose></button>
      </c-modal-header>
      <c-modal-body>
        Approved successfully!
      </c-modal-body>
      <c-modal-footer>
          <button cButton color="secondary" (click)="closeApproveModal()">
            Cancel
          </button>
         
      </c-modal-footer>
  </form>
</c-modal>
<c-modal [visible]="bReject" alignment="center" [backdrop]="'static'">
  <form cForm class="row g-2" [formGroup]="rejectionForm" class="needs-validation" novalidate>
      <c-modal-header>
          <h5 cModalTitle>Confirm</h5>
          <button (click)="closeRejectModal()" cButtonClose></button>
      </c-modal-header>
      <c-modal-body>
        Rejected successfully!
      </c-modal-body>
      <c-modal-footer>
          <button cButton color="secondary" (click)="closeRejectModal()">
            Cancel
          </button>
         
      </c-modal-footer>
  </form>
</c-modal>
<div *ngIf="bShowCifSearchScreen">
  <c-navbar expand="lg" class="border-bottom border-bottom-3 border-bottom-primary">
    <c-container fluid>
      <form cForm class="row g-2" [formGroup]="cifSearchForm" (ngSubmit)="getCifDetails()">
        <div class="row row-cols-auto">
          <div class="col-md-auto">
              <c-input-group class="mb-3 has-validation" >
                  <span cInputGroupText>
                      CIF
                  </span>
                  <input cFormControl formControlName="searchCifControl" id="CIF" placeholder="Company CIF" type="text"/>
              </c-input-group>
          </div>
          <div class="col-sm-auto">
              <button cBgColor="{{searchBtnColor}}" cButton type="submit">
              Search
              </button>
          </div>
          <div class="col-sm-auto">
              <button cBgColor="{{showAllPendingCustomerBtnColor}}" cButton type="button" (click)="getAllPendingCustomers()">
              Show All Pending Customers
              </button>
          </div>
        </div>
        <div class="row row-cols-auto">
          <div class="col">{{companyName}}</div>
        </div>
      </form>
       
    </c-container>
  </c-navbar>

  <c-smart-table
    [columnSorter]="true"
    [columns]="columns"
    [columnFilter]="true"
    [itemsPerPageSelect]="true"
    [itemsPerPage]="15"
    [items]="usersData"
    [tableBodyProps]="{ align: 'middle' }"
    [tableProps]="{ hover: true, striped: true, responsive: true }"
    (rowClick)="rowSelected($event)"
    clickableRows
    header
    pagination>
    <ng-template cTemplateId="tableData" let-columnName="columnName" let-item="item" let-tdContent="tdContent">
      <td>
        <ng-container [ngSwitch]="columnName">
          <ng-container *ngSwitchCase="'createdOn'">
            {{(getDateDisplayString(item))}}
          </ng-container>
          <ng-container *ngSwitchCase="'isMaker'">
            <c-badge [color]="getRoleBadge(item)">
              {{(getRole(item))}}
            </c-badge>
          </ng-container>
          <ng-container *ngSwitchCase="'isCIFLevelAuthority'">
            <c-badge [color]="getAuthorityLevelBadge(item)">
              {{(getAuthorityLevel(item))}}
            </c-badge>
          </ng-container>
          <ng-container *ngSwitchCase="'isApproved'">
            <c-badge [color]="getStatusBadge(item)">
              {{(getStatus(item))}}
            </c-badge>
          </ng-container>
          <ng-container *ngSwitchDefault>
            {{tdContent}}
          </ng-container>
        </ng-container>
      </td>
    </ng-template>
  </c-smart-table>
</div>


<div *ngIf="bShowCustomerDetailsScreen" class="main-height">
  <c-navbar expand="lg" class="border-bottom border-bottom-3 border-bottom-primary">
    <c-container fluid>
      {{companyName}}
      <button [cNavbarToggler]="toolbarCollapseRef"></button>
      <div #toolbarCollapseRef="cCollapse" navbar cCollapse>
        <c-navbar-nav class="me-auto mb-2 mb-lg-0">
          
        </c-navbar-nav>
        <form cForm class="d-flex" role="search">
          <button cTooltip="Go Back" cTooltipPlacement="top" style="margin: 5px;" cButton (click)="goBackToSearchScreen()"><svg cIcon name="cilChevronDoubleLeft"></svg></button>
          <button cBgColor="success" cTooltip="Approve" cTooltipPlacement="top" style="margin: 5px;" cButton (click)="askForApproval()" ><svg cIcon name="cilThumbUp"></svg></button>
          <button cBgColor="danger" cTooltip="Reject" cTooltipPlacement="top" style="margin: 5px;" cButton (click)="showReasonModal()" ><svg cIcon name="cilThumbDown"></svg></button>
        </form>
      </div>
    </c-container>
  </c-navbar>
  
  <div class="row g-2 pt-4">
    <c-nav variant="underline">
      <a [active]="profileTabActive" [cTabContent]="tabContent" [routerLink] [tabPaneIdx]="0" cNavLink>Customer Profile</a>
      <a [active]="matrixTabActive" [cTabContent]="tabContent" [routerLink] [tabPaneIdx]="1" cNavLink>Customer Authority Matrix</a>
    </c-nav>
    <c-tab-content #tabContent="cTabContent" [activeTabPaneIdx]="selectedTab" (activeTabPaneIdxChange)="activeTabPaneIdxChange($event)">
      <c-tab-pane class="p-3">
        <div class="container">
        <form 
          cForm 
          [formGroup]="customerProfileForm"
          class="needs-validation"
          [gutter]="3"
          novalidate>
            <div class="row">
              <div class="col-6">
                <div class="row"><div class="col"><label cLabel for="inputName">Name</label></div><div *ngIf="bApprovedName" class="col"><small><a (click)="showApprovedProfile($event, 1)" href="" style="float: right;">{{bShowingApprovedName?'Show Approved':'Show Pending'}}</a></small></div></div>
                <input readonly cFormControl id="inputName" type="text" formControlName="customerName" />
              </div>
              <div class="col-6">
                <div class="row"><div class="col"><label cLabel for="inputEmail">Email Id</label></div><div *ngIf="bApprovedEmail" class="col"><small><a (click)="showApprovedProfile($event, 2)" href="" style="float: right;">{{bShowingApprovedEmail?'Show Approved':'Show Pending'}}</a></small></div></div>
                <input readonly cFormControl id="inputEmail" type="email" formControlName="customerEmail" />
              </div>
            </div>
            <div class="row pt-2">
              <div class="col-4">
                <div class="row"><div class="col"><label cLabel for="inputMobileNumber">Mobile Number</label></div><div *ngIf="bApprovedMobile" class="col"><small><a (click)="showApprovedProfile($event, 3)" href="" style="float: right;">{{bShowingApprovedMobile?'Show Approved':'Show Pending'}}</a></small></div></div>
                <input readonly cFormControl id="inputMobileNumber" placeholder="Mobile Number" formControlName="customerMobile" />
              </div>
              <div class="col-4">
                <div class="row"><div class="col"><label cLabel for="inputGender">Gender</label></div><div *ngIf="bApprovedGender" class="col"><small><a (click)="showApprovedProfile($event, 4)" href="" style="float: right;">{{bShowingApprovedGender?'Show Approved':'Show Pending'}}</a></small></div></div>
                <select cSelect id="inputGender" name="inputGender" formControlName="customeGender">
                  <option>Male</option>
                  <option>Female</option>
                </select>
              </div>
              <div class="col-4">
                <div class="row"><div class="col"><label cLabel for="inputDateOfBirth">Date Of Birth</label></div><div *ngIf="bApprovedDOB" class="col"><small><a (click)="showApprovedProfile($event, 5)" href="" style="float: right;">{{bShowingApprovedDOB?'Show Approved':'Show Pending'}}</a></small></div></div>
                <c-date-picker  closeOnSelect cFormControl id="inputDateOfBirth" [(date)]="selectedCustomerDateOfBirth" formControlName="customeDateOfBirth"/>
              </div>
            </div>
            <div class="row pt-2">
              <div class="col">
                <div class="row"><div class="col"><label cLabel for="inputIdType">ID Type</label></div><div *ngIf="bApprovedIDType" class="col"><small><a (click)="showApprovedProfile($event, 6)" href="" style="float: right;">{{bShowingApprovedIDType?'Show Approved':'Show Pending'}}</a></small></div></div>
                <select cSelect id="inputIdType" name="inputIdType" formControlName="customerIDType">
                  <option>Passport</option>
                  <option>Emirates ID</option>
                </select>
              </div>
              <div class="col">
                <div class="row"><div class="col"><label cLabel for="inputIdNumber">ID Number</label></div><div *ngIf="bApprovedIDNumber" class="col"><small><a (click)="showApprovedProfile($event, 7)" href="" style="float: right;">{{bShowingApprovedIDNumber?'Show Approved':'Show Pending'}}</a></small></div></div>
                <input cFormControl id="inputIdNumber" placeholder="ID Number" formControlName="customerIDNumber"/>
              </div>
              <div class="col">
                <div class="row"><div class="col"><label cLabel for="inputNationality">Nationality</label></div><div *ngIf="bApprovedNationality" class="col"><small><a (click)="showApprovedProfile($event, 8)" href="" style="float: right;">{{bShowingApprovedNationaility?'Show Approved':'Show Pending'}}</a></small></div></div>
                <select cSelect id="inputNationality" name="inputNationality" formControlName="customerNationality">
                  <option *ngFor="let country of countryList?.dhabiCountries" id="countryList" [value]="country.shortCode">{{country.countryName}}</option>
                </select>
              </div>
              <div class="col">
                <div class="row"><div class="col"><label cLabel for="inputExpiresOn">Expires On</label></div><div *ngIf="bApprovedIDExpiry" class="col"><small><a (click)="showApprovedProfile($event, 9)" href="" style="float: right;">{{bShowingApprovedIDExpiry?'Show Approved':'Show Pending'}}</a></small></div></div>
                <c-date-picker closeOnSelect cFormControl id="inputExpiresOn" [(date)]="selectedCustomerIDExpiresOn" formControlName="customerIDExpiryDate" />
              </div>
            </div>
          </form>
        </div>
      </c-tab-pane>
      <c-tab-pane class="p-3">
        <div class="container">
          <form cForm>
            <div *ngIf="bHasCustomerMatrixApprovalPending" class="row" style="justify-content: flex-end; display: flex; margin-right: auto;">
                <button *ngIf="bShowingApprovedData" cTextColor="white" color="warning" style="margin: 5px;" cButton (click)="showApprovedOrPendingScreen(false)">{{topScreenMessage}}</button>
                <button *ngIf="!bShowingApprovedData" cTextColor="white" color="danger" style="margin: 5px;" cButton (click)="showApprovedOrPendingScreen(true)">{{topScreenMessage}}</button>
            </div>
            <div class="row g-2 pb-3">
              <div class="col-2">
                <label cLabel for="inputName">Role</label>
                <select disabled readonly cSelect id="inputRoleType" name="inputRoleType" [(ngModel)]="selectedCustomerRole">
                  <option>Maker</option>
                  <option>Checker</option>
                </select>
              </div>
              <div class="col-2">
                <label cLabel for="inputEmail">Authority Level</label>
                <select disabled readonly cSelect id="inputAuthorityType" name="inputAuthorityType" [(ngModel)]="selectedCustomerAuthorityLevel">
                  <option>CIF</option>
                  <option>Account</option>
                </select>
              </div>
              <!-- Account permissions are shown in the grid below when Authority Level = Account -->
            </div>

            <c-nav variant="underline">
              <a [active]="true" [cTabContent]="authorityContent" [routerLink] [tabPaneIdx]="0" cNavLink>Master Authorities</a>
              <a [active]="false" [cTabContent]="authorityContent" [routerLink] [tabPaneIdx]="1" cNavLink>{{authorityLevelTabLabel}}</a>
            </c-nav>
            <c-tab-content #authorityContent="cTabContent">
              <c-tab-pane class="p-3">
                <div class="row g-2 pb-3">
                  <div class="col-3">
                    <c-form-check [switch]="true">
                      <input disabled readonly cFormCheckInput type="checkbox" [checked]="bSelectedCustomerFullMasterAuthority"/>
                      <label cFormCheckLabel>All Master Authorities</label>
                    </c-form-check>
                  </div>
                </div>
                <div class="row g-2">
                  <div class="col-3">
                    <c-form-check [switch]="true">
                      <input disabled readonly cFormCheckInput type="checkbox" [checked]="bSelectedCustomerCreateSB"/>
                      <label cFormCheckLabel>Can Create Savings A/c</label>
                    </c-form-check>
                  </div>
                  <div class="col-3">
                    <c-form-check [switch]="true">
                      <input disabled readonly cFormCheckInput type="checkbox" [checked]="bSelectedCustomerCreateCurrent"/>
                      <label cFormCheckLabel>Can Create Current A/c</label>
                    </c-form-check>
                  </div>
                  <div class="col-3">
                    <c-form-check [switch]="true">
                      <input disabled readonly cFormCheckInput type="checkbox" [checked]="bSelectedCustomerRequestCertificate"/>
                      <label cFormCheckLabel>Can Request Certificate</label>
                    </c-form-check>
                  </div>
                  <!--  <div class="col-3">
                    <c-form-check [switch]="true">
                      <input disabled readonly cFormCheckInput type="checkbox" [checked]="bSelectedCustomerChangeMobile"/>
                      <label cFormCheckLabel>Can Change Mobile</label>
                    </c-form-check>
                  </div> -->
                  <div class="col-3">
                    <c-form-check [switch]="true">
                      <input disabled readonly cFormCheckInput type="checkbox" [checked]="bSelectedCustomerChangeAddress"/>
                      <label cFormCheckLabel>Can Change Address</label>
                    </c-form-check>
                  </div>
                <!--  <div class="col-3">
                    <c-form-check [switch]="true">
                      <input disabled readonly cFormCheckInput type="checkbox" [checked]="bSelectedCustomerChangeEmail"/>
                      <label cFormCheckLabel>Can Change Email</label>
                    </c-form-check>
                  </div>-->
                </div>
              </c-tab-pane>
              <c-tab-pane class="p-3">
                <div *ngIf="bSelectedCustomerCIFLevelAuthority" class="row g-2 pb-3">
                 <!--  <div class="col-3">
                    <c-form-check [switch]="true">
                      <input disabled readonly cFormCheckInput type="checkbox" [checked]="bSelectedCustomerViewOnly"/>
                      <label cFormCheckLabel>Can Only View Accounts</label>
                    </c-form-check>
                  </div>-->
                <div class="col-3">
                  <c-form-check [switch]="true">
                    <input disabled readonly cFormCheckInput type="checkbox" [checked]="bSelectedCustomerDeactivateAccount"/>
                    <label cFormCheckLabel>Can Deactivate Accounts</label>
                  </c-form-check>
                </div>
              </div>
              <div *ngIf="bSelectedCustomerCIFLevelAuthority" class="table-responsive mb-4">
                <table class="table table-hover align-middle mb-0">
                  <thead>
                    <tr>
                      <th>
                        <div class="d-flex align-items-center justify-content-between gap-2">
                          <span>Authority Type</span>
                          <c-form-check [switch]="true" class="mb-0">
                            <input disabled readonly cFormCheckInput type="checkbox" [checked]="isAllCifThresholdAuthoritiesEnabled()" />
                            <label cFormCheckLabel>Enable All</label>
                          </c-form-check>
                        </div>
                      </th>
                      <th class="text-center" *ngFor="let currency of cifSupportedCurrencies">{{currency}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let row of cifThresholdRows">
                      <td>
                        <div class="d-flex align-items-center justify-content-between gap-2">
                          <span class="fw-medium">{{row.label}}</span>
                          <c-form-check [switch]="true" class="mb-0">
                            <input disabled readonly cFormCheckInput type="checkbox" [checked]="getCifMatrixEnabled(row.matrixId)" />
                          </c-form-check>
                        </div>
                      </td>
                      <td *ngFor="let currency of cifSupportedCurrencies">
                        <div class="d-flex align-items-center gap-2">
                          <c-input-group class="flex-grow-1 mb-0 has-validation">
                            <input
                              disabled readonly
                              class="text-end"
                              cFormControl
                              [placeholder]="getCifThresholdCell(row.matrixId, currency).unlimited ? 'Unlimited' : 'Threshold'"
                              [value]="getCifThresholdCell(row.matrixId, currency).unlimited ? '' : ((getCifThresholdCell(row.matrixId, currency).threshold > 0 ? getCifThresholdCell(row.matrixId, currency).threshold : 0) | number: '0.0-0': 'en')"
                              type="text" />
                          </c-input-group>
                          <c-form-check [switch]="true" class="mb-0 flex-shrink-0">
                            <input disabled readonly cFormCheckInput type="checkbox" [checked]="getCifThresholdCell(row.matrixId, currency).unlimited" />
                            <label cFormCheckLabel>Max</label>
                          </c-form-check>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Account Level Authorities grid: shown when Authority Level = Account (read-only) -->
              <div *ngIf="!bSelectedCustomerCIFLevelAuthority" class="table-responsive mb-4"
                style="max-height: 50vh; overflow-y: auto; padding-bottom: 3rem;">
                <table class="table table-hover align-middle mb-0">
                  <thead style="position: sticky; top: 0; background: var(--cui-body-bg, #fff); z-index: 1;">
                    <tr>
                      <th style="width: 60px;">
                        <c-form-check [switch]="true">
                          <input disabled readonly cFormCheckInput type="checkbox" [checked]="allAccountsSelected"/>
                        </c-form-check>
                      </th>
                      <th>Accounts</th>
                      <th class="text-center">Fixed Deposits</th>
                      <th class="text-center">Internal Transfer</th>
                      <th class="text-center">Transfer within Dhabi</th>
                      <th class="text-center">Foreign Transfer</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let row of accountMatrixRows">
                      <td>
                        <c-form-check [switch]="true">
                          <input disabled readonly cFormCheckInput type="checkbox" [checked]="row.rowEnabled"/>
                        </c-form-check>
                      </td>
                      <td class="fw-medium">{{row.accountNumber}} {{row.currency || 'USD'}}</td>
                      <td>
                        <div class="d-flex align-items-center gap-2">
                          <c-input-group class="flex-grow-1 mb-0">
                            <input disabled readonly class="text-end" cFormControl placeholder="Threshold"
                              [value]="row.fd.unlimited ? 'Unlimited' : ((row.fd.threshold > 0 ? row.fd.threshold : 0) | number: '0.0-0': 'en')" />
                          </c-input-group>
                          <c-form-check [switch]="true" class="mb-0 flex-shrink-0">
                            <input disabled readonly cFormCheckInput type="checkbox" [checked]="row.fd.unlimited"/>
                            <label cFormCheckLabel>Unlimited</label>
                          </c-form-check>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex align-items-center gap-2">
                          <c-input-group class="flex-grow-1 mb-0">
                            <input disabled readonly class="text-end" cFormControl placeholder="Threshold"
                              [value]="row.internal.unlimited ? 'Unlimited' : ((row.internal.threshold > 0 ? row.internal.threshold : 0) | number: '0.0-0': 'en')" />
                          </c-input-group>
                          <c-form-check [switch]="true" class="mb-0 flex-shrink-0">
                            <input disabled readonly cFormCheckInput type="checkbox" [checked]="row.internal.unlimited"/>
                            <label cFormCheckLabel>Unlimited</label>
                          </c-form-check>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex align-items-center gap-2">
                          <c-input-group class="flex-grow-1 mb-0">
                            <input disabled readonly class="text-end" cFormControl placeholder="Threshold"
                              [value]="row.dhabi.unlimited ? 'Unlimited' : ((row.dhabi.threshold > 0 ? row.dhabi.threshold : 0) | number: '0.0-0': 'en')" />
                          </c-input-group>
                          <c-form-check [switch]="true" class="mb-0 flex-shrink-0">
                            <input disabled readonly cFormCheckInput type="checkbox" [checked]="row.dhabi.unlimited"/>
                            <label cFormCheckLabel>Unlimited</label>
                          </c-form-check>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex align-items-center gap-2">
                          <c-input-group class="flex-grow-1 mb-0">
                            <input disabled readonly class="text-end" cFormControl placeholder="Threshold"
                              [value]="row.foreign.unlimited ? 'Unlimited' : ((row.foreign.threshold > 0 ? row.foreign.threshold : 0) | number: '0.0-0': 'en')" />
                          </c-input-group>
                          <c-form-check [switch]="true" class="mb-0 flex-shrink-0">
                            <input disabled readonly cFormCheckInput type="checkbox" [checked]="row.foreign.unlimited"/>
                            <label cFormCheckLabel>Unlimited</label>
                          </c-form-check>
                        </div>
                      </td>
                    </tr>
                    <tr *ngIf="!accountMatrixRows.length">
                      <td colspan="6" class="text-center text-muted">No company accounts available.</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </c-tab-pane>
          </c-tab-content>
        </form>
      </div>
    </c-tab-pane>
  </c-tab-content>
</div>
</div>